import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBipoc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.6215 4.76058L17.1562 0.477106C16.8789 0.0148601 16.2934 -0.139222 15.8311 0.138126L12.6262 1.95629H9.48294C9.11314 1.95629 8.74334 2.07956 8.43518 2.26446L7.41824 2.9116C7.11008 3.0965 6.95599 3.40466 6.95599 3.74364V7.6265C6.95599 8.33528 7.47987 8.85916 8.18865 8.85916C8.86661 8.85916 9.4213 8.33528 9.4213 7.6265V4.91466H15.0915C16.016 4.91466 16.8172 5.71589 16.8172 6.64038V7.53406L19.2825 6.1165C19.7448 5.83915 19.8989 5.22283 19.6215 4.76058Z",
		fill: "#BF8F68"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.0521 6.12507H10.368V7.85079C10.368 9.08345 9.35106 10.0696 8.14922 10.0696C6.91656 10.0696 5.93044 9.08345 5.93044 7.85079V4.12201L3.92737 5.32385C3.31105 5.66283 2.97207 6.30997 2.97207 7.01875V8.46712L0.506758 9.88467C0.0136962 10.162 -0.140386 10.7783 0.136962 11.2406L2.60227 15.4933C2.87962 15.9863 3.46513 16.1404 3.95819 15.863L7.13228 14.0141H11.3541C12.4327 14.0141 13.3264 13.1512 13.3264 12.0418H13.8194C14.3433 12.0418 14.8056 11.6104 14.8056 11.0557V9.08345H15.0521C15.4527 9.08345 15.7917 8.77528 15.7917 8.34385V6.86467C15.7917 6.46405 15.4527 6.12507 15.0521 6.12507Z",
		fill: "#E0BB95"
	})]
});
export default SvgBipoc;
